import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { safeStorage } from '../lib/safeStorage';

// Routes that remain accessible while `must_read_relapse_doc` is set.
// Emergency contacts, profile, personal-history stay reachable so a
// returning user can update NoK, adjust profile, and complete their
// history if needed.  All programme content is gated behind the
// mandatory read.
const RELAPSE_GATE_ALLOWLIST = [
  '/relapse-message',
  '/profile',
  '/emergency-contacts',
  '/personal-history',
  '/re-engagement',
  '/user-manual',
  '/logout',
];

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsReady(true);
      return;
    }

    if (!loading) {
      if (!user) {
        // Check if invite was verified
        const hasInvite = safeStorage.getItem('invite_verified');
        navigate(hasInvite ? '/login' : '/landing');
      } else if (
        user.must_read_relapse_doc &&
        !RELAPSE_GATE_ALLOWLIST.some((p) => location.pathname === p || location.pathname.startsWith(p + '/'))
      ) {
        // User has an unacknowledged relapse-doc gate — every programme
        // route bounces them to /relapse-message until they clear it.
        navigate('/relapse-message', { replace: true });
      } else {
        setIsReady(true);
      }
    }
  }, [user, loading, navigate, location.state, location.pathname]);

  if (loading || !isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-zinc-100">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-zinc-950 border-r-transparent"></div>
          <p className="mt-4 text-sm font-medium text-zinc-600 uppercase tracking-wider">LOADING</p>
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;